import React, { useEffect, useState } from 'react';
import styles from './monitoring-bar-chart.module.sass';
import { ResponsiveBar } from '@nivo/bar';
import { returnChartColors } from '../../../../redux/utils/chartColors';
import { STATUS } from '../../../../redux/constants';

function MonitoringBarChart(props) {
  const { data, monitoringQueryResultHistoryStatus } = props;
  const [innerTableHeight, setInnerTableHeight] = useState(300);

  const handleResize = () => {
    const tableHeight = document.getElementById('resultHistoryTable')
      ?.offsetHeight;
    setInnerTableHeight(tableHeight);
  };

  useEffect(() => {
    if (window) {
      const tableHeight = document.getElementById('resultHistoryTable')
        ?.offsetHeight;
      setInnerTableHeight(tableHeight);
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (monitoringQueryResultHistoryStatus === STATUS.LOADED) {
      setTimeout(() => {
        handleResize();
      }, 10);
    }
  }, [monitoringQueryResultHistoryStatus]);

  return (
    <div
      className={styles.monitoringBarChart}
      style={{ height: innerTableHeight + 62 + 'px' }}
    >
      <ResponsiveBar
        data={data}
        keys={['observables']}
        indexBy="date"
        margin={{ top: 32, right: 0, bottom: 32, left: 32 }}
        padding={0.3}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={returnChartColors(
          { r: 60, g: 154, b: 323 },
          { r: 240, g: 98, b: 74 },
          data?.length,
        )}
        colorBy="indexValue"
        borderColor={{
          from: 'color',
          modifiers: [['darker', 1.6]],
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legendPosition: 'middle',
          legendOffset: 32,
          truncateTickAt: 0,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legendPosition: 'middle',
          legendOffset: -40,
          truncateTickAt: 0,
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
          from: 'color',
          modifiers: [['darker', 1.6]],
        }}
        legends={[]}
        role="application"
        ariaLabel="Monitoring observables chart"
        barAriaLabel={(e) =>
          e.id + ': ' + e.formattedValue + ' date: ' + e.indexValue
        }
      />
    </div>
  );
}

export default MonitoringBarChart;
